style= require('./transfers.styl')

section.controls
  .panel
    .control
      if seasons
          ft-dropdown.dropdown(icon)
            header.dropdown-header(slot="header")
              if this.sport
                .dropdown-icon
                  ft-icon(name=`sports--${this.sport}`)
              span.dropdown-text=(this.sport) || 'All sports'
            each s in activeSeasons
              .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
                if s
                  .dropdown-icon
                    ft-icon(name=`sports--${s}`)
                span= s
      sporty-seasons(
        sport= this.sport,
        season=season,
        (change:season)=changeSeason(e, 'season'),
        blank="<select a season>")
      sporty-seasons(
        sport= this.sport,
        season=toSeason,
        (change:season)=changeSeason(e, 'toSeason'),
        blank="<select a season>")
      .spacer
      ft-button.confirm(
        success,
        disabled=!canSubmit,
        (click)=this.save()
      )='Copy'
section.teams-info
  for side in ['from', 'to']
    - var teams = getTeams(side)
    .field.entries
      .title
        .counter
          .name= side
          .count.sourced= teams.length
        ft-form-control.search(
          type='search',
          (input)=this.updateFilter(e),
          placeholder='Team')
        if side == 'from'
          ft-toggle(
            checked=allTeamsSelected,
            (toggle)=toggleAll()
          ) Copy All
      if teams.length
        each team in teams
          .entry(data-team=team._id)
            section
              ft-clipboard.id
                span= team._id
                span.match-icon
                  ft-icon(name=`ui--clipboard`)
              if side === 'from'
                ft-toggle.copy(
                  darken,
                  checked=isSelected(team),
                  (toggle)=this.toggle(team)
                ) Copy
            .header
              = team.name
              if team.abbr
                .tag= ' (' + (team.abbr) + ')'
              if team.tag
                .tag= ' #' + (team.tag)
      else
        .no-players
          ft-icon(name='ui--match')
          .text= 'No teams to display'
